// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","conection":"footer_conection__oASkZ","reserved":"footer_reserved__gXYGo","talk":"footer_talk__Jcv0V"};